import React from "react";

import { ReactComponent as OpenExternalIcon } from "@common/assets/images/external-open-icon.svg";
import Tooltip from "@common/components/Tooltip/Tooltip";

import * as Styles from "./OpenExternalButton.styles";

interface OpenExternalButtonProps {
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const OpenExternalButton = ({ style, onClick }: OpenExternalButtonProps) => {
  return (
    <Tooltip
      style={{ display: "flex", alignItems: "center", width: "auto" }}
      text={"Open in new tab"}
      position={"top"}
    >
      <Styles.OpenExternalButton
        style={style}
        onClick={onClick}
      >
        <OpenExternalIcon />
      </Styles.OpenExternalButton>
    </Tooltip>
  );
};
